module.exports = __webpack_public_path__ + "f9ba02ca526bfbdbebe0ef3e6c27e91c.svg";